import {Base} from "@/api/Base"

export class RoleList extends Base {
    path = "role/list"
}